/**
 * フッターに表示するトピック取得
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'

// driver/api/v1/topics
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/topics`


const driver_topic = {
  namespaced: true,

  state: {},

  getters: {},

  actions: {
    show() {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          const topic = data.content.topic 
          resolve(topic)
        })
      })
    },
    create(_, { topic_id }) {
      return new Promise((resolve) => {
        Vue.$http.post(`${API_PATH}/${topic_id}/reads`, { topic_id }).then(() => {
          resolve()
        })
      })
    }
  }
}

export default driver_topic


